/* eslint-disable @atlassian/relay/graphql-naming */
/* eslint-disable jira/filename-case */
import React, { useCallback } from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { Flex } from '@atlaskit/primitives/compiled';
import { Pagination as BasePagination } from '@atlassian/jira-directory-base-v3/src/ui/pagination/Pagination.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	DEFAULT_LIMIT,
	FilterFields,
} from '@atlassian/jira-projects-directory-v3-utils/src/constants.tsx';
import type { PaginationPagination$key } from '@atlassian/jira-relay/src/__generated__/PaginationPagination.graphql';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { useScopedFilter } from '../../../../controllers/filter-state/index.tsx';

type Props = {
	projectsRef: PaginationPagination$key;
};

export const Pagination = ({ projectsRef }: Props): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: 'changed',
		actionSubject: 'resultsTable',
	});
	const [value, { updateFilter }] = useScopedFilter(FilterFields.Page);
	const currentPage = parseInt(value, 10);

	const dataRef = useFragment<PaginationPagination$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment PaginationPagination on JiraProjectConnection {
				...Pagination
			}
		`,
		projectsRef,
	);

	const handleChange = useCallback(
		(page: number) => {
			updateFilter(FilterFields.Page, page.toString());
			fireUIAnalytics(analyticsEvent, 'PageNumber');
		},
		[analyticsEvent, updateFilter],
	);

	if (isVisualRefreshEnabled()) {
		return (
			<Flex alignItems="center" justifyContent="center">
				<BasePagination
					dataRef={dataRef}
					itemsPerPage={DEFAULT_LIMIT}
					currentPage={currentPage}
					onChange={handleChange}
				/>
			</Flex>
		);
	}

	return (
		<BasePagination
			dataRef={dataRef}
			itemsPerPage={DEFAULT_LIMIT}
			currentPage={currentPage}
			onChange={handleChange}
		/>
	);
};
